import { api } from '../api.js';
import { store } from '../store.js';
import { navigate } from '../router.js';

export async function renderLoginPage({ root }) {
  renderCredentials(root);
}

function renderCredentials(root) {
  root.innerHTML = `
    <div class="auth-wrapper">
      <form class="auth-card" id="login-form">
        <h1>Chunkly.ru</h1>
        <div class="form-error" id="form-error"></div>
        <div class="field">
          <label for="email">Email</label>
          <input type="email" id="email" name="email" required autocomplete="email" />
        </div>
        <div class="field">
          <label for="password">Пароль</label>
          <input type="password" id="password" name="password" required autocomplete="current-password" />
        </div>
        <div class="actions">
          <button type="submit" id="submit-btn">Войти</button>
        </div>
        <div class="alt">
          Нет аккаунта? <a href="/register" data-link>Регистрация</a>
        </div>
        <div class="alt">
          <a href="/forgot-password" data-link>Забыл пароль?</a>
        </div>
      </form>
    </div>
  `;

  const form = root.querySelector('#login-form');
  const errEl = root.querySelector('#form-error');
  const btn = root.querySelector('#submit-btn');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errEl.textContent = '';
    btn.disabled = true;
    const fd = new FormData(form);
    const email = fd.get('email');
    try {
      const res = await api.auth.login(email, fd.get('password'));
      if (res?.pinRequired && res?.challengeToken) {
        renderPinStep(root, res.challengeToken, email);
        return;
      }
      store.user = res.user;
      navigate('/');
    } catch (err) {
      if (err.status === 401) errEl.textContent = 'Неверные email или пароль';
      else if (err.status === 502 && err.body?.error === 'pin_send_failed') {
        errEl.textContent = 'Не получилось отправить PIN в Telegram. Проверь настройки бота.';
      } else errEl.textContent = 'Ошибка: ' + (err.message || 'попробуйте снова');
    } finally {
      btn.disabled = false;
    }
  });
}

function renderPinStep(root, challengeToken, email) {
  root.innerHTML = `
    <div class="auth-wrapper">
      <form class="auth-card" id="pin-form">
        <h1>PIN-код</h1>
        <p class="text-muted">Мы отправили 6-значный код в Telegram-чат админа. Введи его ниже.</p>
        <p class="text-muted" style="font-size:.85rem;">Аккаунт: <strong>${escapeHtml(email)}</strong></p>
        <div class="form-error" id="pin-error"></div>
        <div class="field">
          <label for="pin">PIN</label>
          <input type="text" id="pin" name="pin" inputmode="numeric" pattern="\\d{6}" maxlength="6" autocomplete="one-time-code" required autofocus />
        </div>
        <div class="actions">
          <button type="submit" id="pin-submit">Подтвердить</button>
        </div>
        <div class="alt">
          <a href="#" id="pin-back">← Войти под другим аккаунтом</a>
        </div>
      </form>
    </div>
  `;

  const form = root.querySelector('#pin-form');
  const errEl = root.querySelector('#pin-error');
  const btn = root.querySelector('#pin-submit');
  const pinInput = root.querySelector('#pin');

  pinInput.addEventListener('input', () => {
    pinInput.value = pinInput.value.replace(/\D/g, '').slice(0, 6);
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errEl.textContent = '';
    if (!/^\d{6}$/.test(pinInput.value)) {
      errEl.textContent = 'Код должен состоять из 6 цифр';
      return;
    }
    btn.disabled = true;
    try {
      const res = await api.auth.loginPin(challengeToken, pinInput.value);
      store.user = res.user;
      navigate('/');
    } catch (err) {
      if (err.status === 401 && err.body?.error === 'invalid_pin') {
        errEl.textContent = 'Неверный код. Попробуй ещё раз.';
      } else if (err.body?.error === 'expired') {
        errEl.textContent = 'Код просрочен. Войди заново, чтобы получить новый.';
      } else if (err.body?.error === 'too_many_attempts') {
        errEl.textContent = 'Слишком много попыток. Войди заново.';
      } else if (err.body?.error === 'not_found') {
        errEl.textContent = 'Сессия не найдена. Войди заново.';
      } else {
        errEl.textContent = 'Ошибка: ' + (err.message || 'попробуйте снова');
      }
    } finally {
      btn.disabled = false;
    }
  });

  root.querySelector('#pin-back').addEventListener('click', (e) => {
    e.preventDefault();
    renderCredentials(root);
  });
}

function escapeHtml(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
